import React, { Fragment } from 'react';
import { Container } from 'reactstrap';
import { ArcaHttpClientPageDetails } from '../code/ArcaHttpClientPageDetails.js';
import { ArcaHttpSystem } from '../code/ArcaHttpSystem.js';
import { ArcaSecurity } from '../code/ArcaSecurity.js';
import { FirstItemOnPage } from './controls/PageDetails/FirstItemOnPage.jsx';
import { PageDetailsPanel } from './controls/PageDetails/PageDetailsPanel.jsx';
import { ContactPanel } from './controls/People/ContactPanel.jsx';
import { ArcaComponent } from './pages/ArcaComponent.js';

export class Home extends ArcaComponent {

    constructor(props) {
        super(props);

        this.logoff = this.logoff.bind(this);

        this.state = {
            showDescriptiveText: false,
            pageDetails: null,
            pageListDetails: null
        };
    }

    processDetails(details) {
        this.setState({ pageListDetails: details });
        ArcaHttpSystem.Log("Got details")
    }

    logoff() {
        ArcaSecurity.Logoff();
        this.setState({

        });
    }

    getContainerClass() {

        return ArcaHttpSystem.IsSmartphone
            ? 'NoPadding'
            : 'NoPadding';
    }

    componentWillUnmount() {
        ArcaHttpSystem.ShowUserMenu = false;
    }

    componentDidMount() {
        ArcaHttpSystem.ShowUserMenu = true;
        ArcaHttpClientPageDetails.GetListAsync('Main',
            (details => this.processDetails(details)));
    }

    render() {
        const { pageListDetails } = this.state;
        ArcaHttpSystem.Log(`Home: container class ${this.getContainerClass()}`)

        return (

            !pageListDetails
                ? <Fragment>
                    Page is loading ...
                </Fragment>

                : <Fragment>
                    <Container id='#top' fluid className={this.getContainerClass()}>

                        {pageListDetails?.map((details, key) =>
                            <Fragment key={key}>
                                {key === 0
                                    ? <Fragment>
                                        <FirstItemOnPage details={details} />

                                        <h1 id='ourServices' className='subSectionHeader' >Services</h1>
                                    </Fragment>
                                    :
                                    <div className='rounded px-3 px-sm-4 py-3 py-sm-5 article' >
                                        <PageDetailsPanel details={details} index={key} />
                                    </div>}
                            </Fragment>
                        )}

                        <ContactPanel />
                    </Container>
                </Fragment>
        );
    }
}
